/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A10Inputs */

const en_pc_faq_a10 = /** @type {(inputs: Pc_Faq_A10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not yet. ArtCraft ships PdfCraft for desktop systems and the web. On a phone or tablet you can try PdfCraft Online in the browser, although the desktop layout works best on larger screens.`)
};

const zh_pc_faq_a10 = /** @type {(inputs: Pc_Faq_A10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂时没有。ArtCraft 目前只提供桌面版和网页版。在手机或平板上可以通过浏览器试用 PdfCraft 在线版，不过桌面布局在大屏幕上体验最好。`)
};

/**
* | output |
* | --- |
* | "Not yet. ArtCraft ships PdfCraft for desktop systems and the web. On a phone or tablet you can try PdfCraft Online in the browser, although the desktop layou..." |
*
* @param {Pc_Faq_A10Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a10 = /** @type {((inputs?: Pc_Faq_A10Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A10Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a10(inputs)
	return zh_pc_faq_a10(inputs)
});
export { pc_faq_a10 as "pc.faq.a10" }